import { render } from "./ButtonInertiaLink.vue?vue&type=template&id=6837e270"
import script from "./ButtonInertiaLink.vue?vue&type=script&lang=js"
export * from "./ButtonInertiaLink.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/web/driving-school-be/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ButtonInertiaLink.vue"]])

export default __exports__